import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { DataService } from 'src/app/Service/data.service';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-prestamos',
  templateUrl: './prestamos.component.html',
  styleUrls: ['./prestamos.component.css']
})
export class PrestamosComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public isShow: boolean = false;
  public pagart: number = 0;
  public funcion: Function = null;
  public isclosed: Boolean = false;
  public filtro: Filtro = new Filtro();
  public pagina: number = 0;
  public detfactus: any[] = [];
  public usuario = null;
  public modal = "modal-lg";
  options: ALertOption;
  listpersonal: any[] = [];
  constructor(private data: DataService) {

  }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.usuario = this.data.getCurrentUser();
    this.filtro.isprestamo = true;
    this.filtro.idfactura__idsucursal = this.data.getSucursalId()
    setTimeout(() => {
      console.log(this.usuario);

      this.btnshow.nativeElement.click();
      this.GetData();
      this.getPersonal()
      this.info.hide();


    }, 10);
  }

  GetData1() {
    console.log(this.usuario);

    const filtro: any = {
      idfactura__idsucursal: this.data.getSucursalId(),
      isprestamo: true,
      tipofecha: 'fecha'
    }

    if (this.usuario.idpersonal.idnivel != 1) {
      filtro.idfactura__idvende = this.usuario.idpersonal.idpersonal
    }

    this.data.Post('filtrardoc/Detfactu', filtro).subscribe(
      (r) => {
        console.log(r);
        if (r.data) {
          this.detfactus = r.data;
          console.log("Data Prestamos:", this.detfactus);
        } else {
          this.detfactus = [];
        }

      },
      (e) => { console.log(e); this.detfactus = []; });
  }

  GetData() {
    const filtro: any = {
      idfactura__idsucursal: this.data.getSucursalId(),
      isprestamo: true,
    }

    // Admin ve todos, vendedor solo los suyos con filtro de fecha
    if (this.usuario.idpersonal.idnivel != 1) {
      filtro.idfactura__idvende = this.usuario.idpersonal.idpersonal
      filtro.tipofecha = 'fecha'  // solo hoy para vendedor
    }
    // Admin: sin tipofecha → ve histórico completo

    this.data.Post('filtrardoc/Detfactu', filtro).subscribe(
      (r) => {
        if (r.data) {
          this.detfactus = r.data;
        } else {
          this.detfactus = [];
        }
      },
      (e) => { this.detfactus = []; }
    );
  }

  close() {
    if (!this.isclosed) {
      this.btnclose.nativeElement.click();
    }
    setTimeout(() => { this.isShow = false; }, 200);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  ActualizarPrestamo(det) {
    if (det.saldo == 0) {
      det.isprestamo = false
    }
    return this.data.Put(this.data.api.detfactura, det.id_det, det);
  }

  GuardarDatos() {
    const updateObservables = this.detfactus.map(element => this.ActualizarPrestamo(element));
    forkJoin(updateObservables).subscribe(
      (results) => {
        this.data.notify("Datos actualizados correctamente", "Exito", this.data.alertType.success, this.options, () => { this.close() });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  change_saldo(det) {
    console.log(det);

    if (det.ingreso <= det.cantidad) {
      det.saldo = det.cantidad - det.ingreso;

      return det
    } else {
      this.data.notify("La cantidad entregada no puede ser mayor a la cantidad original", "Error", this.data.alertType.error);
      return det
    }
  }


  onRecojoInput(item: any): void {
    // inicializaciones seguras si no se hizo init
    item.saldo = Number(item.saldo) || 0;
    item.ingreso = Number(item.ingreso) || 0;
    if (item._appliedRecojo === undefined) item._appliedRecojo = 0;
    if (item.recojo === undefined) item.recojo = 0;

    // calcular límite máximo posible: saldo actual + lo ya aplicado (resta a lo original)
    const maxAllowed = Number(item.saldo) + Number(item._appliedRecojo);

    // convertir y clamar el valor de recojo en [0, maxAllowed]
    let recojo = Number(item.recojo) || 0;
    recojo = Math.max(0, Math.min(maxAllowed, recojo));
    item.recojo = recojo;

    // aplicar solo la diferencia (delta) respecto a lo ya aplicado
    const delta = recojo - Number(item._appliedRecojo);

    // ajustar saldo e ingreso
    item.saldo = Number(item.saldo) - delta;
    item.ingreso = Number(item.ingreso) + delta;

    // actualizar cuánto se ha aplicado en total para esta fila
    item._appliedRecojo = recojo;

    // opcional: debug
    // console.log('onRecojoInput', { recojo, delta, saldo: item.saldo, ingreso: item.ingreso });
  }

  getPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe(r => {
      console.log(r);
      this.listpersonal = r;
    });
  }

  getObjPersonal(idpersonal): any {
    const obj = this.listpersonal.find(p => p.idpersonal == idpersonal);
    if (obj) {
      return obj.nombre;
    }
    return 'N/A';
  }
}
